import { Box, Button } from "@mui/material";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { AgreementKindEnum } from "../../../schemas/agreements";
import WindowService from "../../../services/windowService";

import DateService from "../../../services/dateService";

export const AgreementKindLinkDisplay = (props) => {
    const {
        currentAgreementKindKey,
        reservationAgreementId,
        preinitialAgreementId,
        developmentAgreementId,
        salesAgreementId,
        agreementBooking
    } = props;
    const { t } = useTranslation();


    return (
        <Box sx={{ display: "flex" }}>
            <LinkButton
                label={agreementBooking ? `${t("agreements.AgreementPassportDialog.bookingNr")}: ${agreementBooking.agrebook_booking.booking_nr} ${t("agreements.AgreementPassportDialog.transformationDate")}: ${DateService.convertDatetimeFromBackendToFormatDDMMYYYY(agreementBooking.created)}`  : t("agreements.AgreementPassportDialog.noBooking")}
                isCurrentlySelected={false}
                agreementId={null}
                sx={{textTransform :"capitalize", padding: 0, margin: 0}}
            />
            <LinkButton
                label={t("agreements.kinds.reservation")}
                isCurrentlySelected={AgreementKindEnum.RESERVATION === currentAgreementKindKey}
                agreementId={reservationAgreementId}
            />
            <LinkButton
                label={t("agreements.kinds.preInitial")}
                isCurrentlySelected={AgreementKindEnum.PRE_INITIAL === currentAgreementKindKey}
                agreementId={preinitialAgreementId}
            />
            <LinkButton
                label={t("agreements.kinds.developer")}
                isCurrentlySelected={AgreementKindEnum.DEVELOPER === currentAgreementKindKey}
                agreementId={developmentAgreementId}
            />
            <LinkButton
                label={t("agreements.kinds.sales")}
                isCurrentlySelected={AgreementKindEnum.SALES === currentAgreementKindKey}
                agreementId={salesAgreementId}
            />
        </Box>
    );
};

const LinkButton = (props) => {
    const { label, agreementId, isCurrentlySelected } = props;

    const handleOpenPassportInNewTab = useCallback(() => {
        if (!agreementId || isCurrentlySelected) {
            return;
        }

        WindowService.openInNewTab(`/agreements/passport/${agreementId}/`);
    }, [agreementId, isCurrentlySelected]);

    const disabled = !agreementId;

    return (
        <Button
            onClick={handleOpenPassportInNewTab}
            disabled={disabled}
            variant={isCurrentlySelected ? "contained" : "outlined"}
            sx={{ flex: 1, ...props.sx }}
        >
            {label}
        </Button>
    );
};
